import loadable from '@loadable/component'

export default {
  '/api/zmweb/v1/user/smsLoginCode': loadable(() => import('./mock')),
  '/api/zmapp/v1/user/ping': loadable(() => import('./mock')),
}
